import { render, staticRenderFns } from "./LastSamplesEmptyState.vue?vue&type=template&id=34195d04&scoped=true"
import script from "./LastSamplesEmptyState.vue?vue&type=script&lang=js"
export * from "./LastSamplesEmptyState.vue?vue&type=script&lang=js"
import style0 from "./LastSamplesEmptyState.vue?vue&type=style&index=0&id=34195d04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34195d04",
  null
  
)

export default component.exports